var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMobileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 28,
    viewBox: "0 0 46 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4629 22.9748L0.342349 27.6105C0.200064 27.6607 0.0332031 27.5877 0.0332031 27.475V0.517822C0.0332031 0.40644 0.198124 0.333487 0.339762 0.381688L13.4629 4.86435V22.9748Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0098 4.87351L17.0825 0.110107V27.8874L14.0098 22.9748V4.87351Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMobileLogo);
export default __webpack_public_path__ + "static/media/ic-mobile-logo.f40a5bd458bd95c2a1f67d9ad2bdae16.svg";
export { ForwardRef as ReactComponent };